import AHRIRelatedProductState from "@crescentParts/Store/Data/AHRIRelatedProduct/AHRIRelatedProductState";
import { RelatedProductModel } from "@crescentParts/Store/Data/AHRIRelatedProduct/Handler/AHRIRelatedProductHandler";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: AHRIRelatedProductState = {
    isLoading: false,
    relatedProductLines: [],
    ahriRelatedProductInfosByLineId: {}
};

const reducer = {
    "Custom/LoadRelatedProducts": (draft: Draft<AHRIRelatedProductState>, action: { result: RelatedProductModel }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteLoadRelatedProducts": (
        draft: Draft<AHRIRelatedProductState>,
        action: { relatedProductLines : {result: RelatedProductModel } },
    ) => {
        draft.isLoading = false;
        draft.relatedProductLines = action.relatedProductLines as any;
    },
    "Custom/RelatedProducts/SetRealtimePricingAndInventory": (
        draft: Draft<AHRIRelatedProductState>,
        action: { ahriRelatedProductInfosByLineId: any },
    ) => {
        draft.ahriRelatedProductInfosByLineId = action.ahriRelatedProductInfosByLineId.productInfosByLineId;
    },
    "Custom/relatedProductInfoLists/UpdateRelatedProductInfo": (
        draft: Draft<AHRIRelatedProductState>,
        action: {
            productId: string;
            qtyOrdered?: number;
            unitOfMeasure?: string;
        },
    ) => {
        if(draft?.ahriRelatedProductInfosByLineId) {
            const productInfo = draft?.ahriRelatedProductInfosByLineId[action.productId]
            if (!productInfo) {
                return;
            }
    
            productInfo.qtyOrdered = action.qtyOrdered ?? productInfo.qtyOrdered;
            productInfo.unitOfMeasure = action.unitOfMeasure ?? productInfo.unitOfMeasure;
            productInfo.failedToLoadInventory = true;
        }
    },
    "Components/ProductInfoLists/FailedLoadRealTimeInventory": (
        draft: Draft<AHRIRelatedProductState>,
        action: { id: string },
    ) => {
        if(draft?.ahriRelatedProductInfosByLineId) {
            for (const key in draft.ahriRelatedProductInfosByLineId) {
                const productInfo = draft.ahriRelatedProductInfosByLineId[key];
                if (!productInfo) {
                    continue;
                }
                productInfo.failedToLoadInventory = true;
            }
        }

        
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
